// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPaginationBigRight = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24">
            <polygon
                fill="currentColor"
                points="11.482 25 12.437 26.204 20.266 36.074 21 37 20.266 37.926 11.482 49 9 47.148 9.955 45.945 17.049 37 9.955 28.055 9 26.852"
                transform="translate(-9 -25)"
            />
        </svg>
    );
};

export default React.memo(IconPaginationBigRight);
